// List of usernames to filter out from the data grid
export const FILTERED_USERNAMES = [
  "cloudcatcher.support",
  "cloudcatcher.bary",
  "cloudcatcher.ram",
  "cloudcatcher.sher",
  "cloudcatcher.anani",
  "cloudcatcher.ram.perumal",
  "bary.azmi",
  "sher.nasir",
  "anani.folly",
  "ram.perumal",
  "RamPrakash.Perumal"
];

// Function to check if a username should be filtered out
export const shouldFilterUsername = (username) => {
  if (!username) return false;

  // Only filter usernames if environment is trial
  if (process.env.REACT_APP_ENVIRONMENT !== "Trial") {
    return false;
  }

  const lowerUsername = username.toLowerCase();
  return FILTERED_USERNAMES.some((filteredName) =>
    lowerUsername.startsWith(filteredName.toLowerCase())
  );
};

// Function to check if the current Organization is an MSP user
export const isMSP = () => {
  try {
    const isMspOrg = localStorage.getItem("isMspOrg");
    return isMspOrg === "true";
  } catch (error) {
    console.error("Error checking MSP status:", error);
    return false;
  }
};

// Function to check if the current Organization is an MSP user
export const isMSPUser = () => {
  try {
    const mspUser = localStorage.getItem("mspUser");
    return mspUser === "true";
  } catch (error) {
    console.error("Error checking MSP status:", error);
    return false;
  }
};

/**
 * Checks if Margin Management UI should be visible
 * Returns true only for MSP users in MSP organizations
 * Used for both menu visibility and route access control
 */
export const isMarginManagementUIVisible = () => {
  try {
    const isVisible = localStorage.getItem("isMarginMangementUIVisible");
    return isVisible === "true";
  } catch (error) {
    console.error(
      "Fetching Status for margin management UI visibility: ",
      error
    );
    return false;
  }
};

/**
 * Checks if Margin Management Dashboard should be visible
 * Returns true for MSP users in NON-MSP organizations
 * Used for showing margin management dashboard in Cost Spend section
 */
export const isMarginManagementDashboardVisible = () => {
  try {
    const isVisible = localStorage.getItem(
      "isMarginmanagementDashboardVisible"
    );
    return isVisible === "true";
  } catch (error) {
    console.error(
      "Fetching Status for margin management dashboard visibility: ",
      error
    );
    return false;
  }
};

/**
 * Checks if Customer Summary Dashboard should be visible
 * Returns true only for MSP organizations (orgCode === mspOrgCode && msp)
 * Used for showing Customer Summary menu item
 */
export const isCustomerSummaryDashboardVisible = () => {
  try {
    const isVisible = localStorage.getItem("isCustomerSummaryDashboardVisible");
    return isVisible === "true";
  } catch (error) {
    console.error(
      "Error checking Customer Summary Dashboard visibility: ",
      error
    );
    return false;
  }
};


export const convertDate = (dateInput) => {
  console.log("🚀 ~ convertDate ~ dateInput:", dateInput);

  // If input is null, undefined, or 'null', return empty string
  if (!dateInput || dateInput === "null") {
    return "";
  }

  // Handle object format (like subscription_modified_date)
  if (typeof dateInput === "object" && dateInput.date && dateInput.time) {
    const { year, month, day } = dateInput.date;
    console.log("🚀 ~ convertDate ~ year, month, day:", year, month, day);
    return `${month}/${day}/${year}`; // Format as MM/DD/YYYY
  }

  // Handle string date (like createdDate)
  const dt = new Date(dateInput);

  // Check for invalid date
  if (isNaN(dt.getTime())) {
    return ""; // Return empty string for invalid date
  }

  return `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}`; // Format as MM/DD/YYYY
};
